import { SET_RESOURCES_IN_HOUR, SET_LEVELS_IN_PLACE_BY_ENTITITES } from "./types";

const WidgetResourcesInHourReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_RESOURCES_IN_HOUR:
            return {
                ...state,
                resources: payload,
                isFetching: false,
                error: {
                    ok: false,
                    text: ''
                }
            }
        case SET_LEVELS_IN_PLACE_BY_ENTITITES:
            return {
                ...state,
                resourcesInPlaceByEntities: { ...state.resourcesInPlaceByEntities, levels: payload },
            }
        default:
            return state;
    }
}

export default WidgetResourcesInHourReducer